// Core app constants — Lightning Partners HQ dark theme palette
export const N = '#1C1C1E';
export const NL = '#2A2A2E';
export const R = '#4ADE80';
export const RL = '#2A2A2E';
export const COLORS = ['#1C1C1E', '#0A0A0A', '#0d9488', '#ca8a04', '#6366f1', '#4ADE80', '#f59e0b', '#ec4899', '#8b5cf6', '#06b6d4'];

// Re-export everything from site-constants for convenience
export * from './site-constants';
